<template>
  <HorizontalWideBarChart
    v-bind:title="title"
    v-bind:data="data"
    v-bind:labels="labels"
  />
</template>

<script>
import HorizontalWideBarChart from "@/components/management/statistics/common/HorizontalWideBarChart";
import { getAccessByCountryChartData } from "@/api/statisticsV2";

export default {
  components: {
    HorizontalWideBarChart,
  },
  data() {
    return {
      title: "Access by Country",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByCountryChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
